module.exports = __webpack_public_path__ + "static/img/liBgImage4-hover.d298e80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/technicalAdvantages/liBgImage4-hover.png
// module id = n/2o
// module chunks = 7